<script>
import { Field, Toast, Dialog } from 'vant'
import RadioGroupField from '@/components/org/RadioGroupField'
import PickerSelector from '@/components/org/PickerSelector'
import BottomToolbar from '@/components/org/BottomToolbar'
import ObjectFunc from '@/tbs/util/ObjectFunc'

import GameEvent from '@/tbs/model/vo/GameEvent'
const gameEvent = new GameEvent

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-game-event-edit',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-field': Field,
        'radio-group-field': RadioGroupField,
        'picker-selector': PickerSelector,
        'bottom-toolbar': BottomToolbar,
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            game: {
                gameId: null,
                homeTeamId: null,
                awayTeamId: null,
                homeTeamName: null,
                awayTeamName: null,
                matchGroupId: null,
            },
            playerList: {
                homeTeamPlayers: null,
                awayTeamPlayers: null,
            },
            event: {
                id: null,
                time: null,
                teamId: null,
                eventType: null,
                eventSpecType: null,
                firstPlayerId: null,
                secondPlayerId: null,
            },
            isEdit: null,
            locale: {}
        }
    },
    
    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
        teamList() {
            return [ 
                { label: this.game.homeTeamName, value: this.game.homeTeamId },
                { label: this.game.awayTeamName, value: this.game.awayTeamId },
            ]
        },
        team() {
            return this.getTeamId()
        },
        eventTypeList() {
            return gameEvent.getEventTypes()
        },
        eventType() {
            return this.getEventType()
        },
        eventSpecTypeList() {
            return gameEvent.getEventSpecTypes(this.getEventType())
        },
        eventSpecType() {
            return this.getEventSpecType()
        },
        firstPlayerLabel() {
            return gameEvent.getFirstPlayerLabel(this.event.eventType, this.event.eventSpecType)
        },
        firstPlayerList() {
            console.log('@firstPlayerList', this.event.teamId, this.game, this.playerList)
            /*const addNewPlayer = { 
                id: '-1', 
                label: this.locale['add-new-player'], 
                value: '-1'
            }
            if (this.event.teamId == this.game.awayTeamId) {
                return this.playerList.awayTeamPlayers ? this.playerList.awayTeamPlayers.concat([addNewPlayer]) : []
            }
            else {
                return this.playerList.homeTeamPlayers ? this.playerList.homeTeamPlayers.concat([addNewPlayer]) : []
            }*/
            if (this.event.teamId == this.game.awayTeamId) {
                return this.playerList.awayTeamPlayers ? this.playerList.awayTeamPlayers : []
            }
            else {
                return this.playerList.homeTeamPlayers ? this.playerList.homeTeamPlayers : []
            }
        },
        firstPlayerField() {
            return this.event.firstPlayerId
        },
        secondPlayerLabel() {
            return gameEvent.getSecondPlayerLabel(this.event.eventType, this.event.eventSpecType)
        },
        secondPlayerList() {
            /*const addNewPlayer = { 
                id: '-1', 
                label: this.locale['add-new-player'], 
                value: '-1'
            }
            if (this.event.teamId == this.game.awayTeamId) {
                const awayTeamPlayers = this.playerList.awayTeamPlayers ? this.playerList.awayTeamPlayers.filter(player => player.id != this.event.firstPlayerId) : []
                return awayTeamPlayers.concat([addNewPlayer])
            }
            else {
                const homeTeamPlayers = this.playerList.homeTeamPlayers ? this.playerList.homeTeamPlayers.filter(player => player.id != this.event.firstPlayerId) : []
                return homeTeamPlayers.concat([addNewPlayer])
            }*/
            if (this.event.teamId == this.game.awayTeamId) {
                return this.playerList.awayTeamPlayers ? this.playerList.awayTeamPlayers.filter(player => player.id != this.event.firstPlayerId) : []
            }
            else {
                return this.playerList.homeTeamPlayers ? this.playerList.homeTeamPlayers.filter(player => player.id != this.event.firstPlayerId) : []
            }
        },
        secondPlayerField() {
            return this.event.secondPlayerId
        },
        hasEventSpecTypeList() {
            return gameEvent.validateEventSpecTypeRequired(this.event.eventType)
        }
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onFieldInput() {
        },
        onTeamDataChange(data) {
            console.log('onTeamDataChange', data)
            this.event.teamId = data
            // this.event.eventType = null
            // this.event.eventSpecType = null
            this.event.firstPlayerId = null
            this.event.secondPlayerId = null
            this.event.eventType = gameEvent.defaultEventType
            this.event.eventSpecType = gameEvent.defaultEventSpecType
        },
        onEventTypeDataChange(data) {
            console.log('onEventTypeDataChange', data)
            this.event.eventType = data
            // this.event.eventSpecType = null
            this.event.firstPlayerId = null
            this.event.secondPlayerId = null
            this.event.eventSpecType = gameEvent.getEventSpecTypes(data)[0].value
        },
        onEventSpecTypeDataChange(data) {
            console.log('onEventSpecTypeDataChange', data)
            this.event.eventSpecType = data
            this.event.firstPlayerId = null
            this.event.secondPlayerId = null
        },
        onFirstPlayerDataChange(data) {
            console.log('onFirstPlayerDataChange', data)
            if (data.value === '-1') {
                // navigate to the create player page
                this.$emit('custom-event', {
                    type: 'navigate',
                    data: {
                        name: 'OrgCreatePlayer',
                        query: ObjectFunc.mergeObject({
                            teamId: this.getTeamId(),
                            from: this.isEdit ? 'OrgEditGameEvent' : 'OrgCreateGameEvent'
                        }, this.game),
                        isReplace: false
                    }
                })
            }
            else {
                this.event.firstPlayerId = data.value
            } 
        },
        onSecondPlayerDataChange(data) {
            console.log('onSecondPlayerDataChange', data)
            this.event.secondPlayerId = data.value
        },
        getTeamId() {
            return this.event.teamId
        },
        getEventType() {
            return this.event.eventType
        },
        getEventSpecType() {
            return this.event.eventSpecType
        },
        onSubmitBtnClick() {
            console.log('onSubmitBtnClick')
            if (!this.validateSubmitRequired()) {
                // disable to submit and toast the message
                if (!this.event.time) {
                    Toast(this.locale['event-time-required'])
                }
                else if (!this.event.teamId) {
                    Toast(this.locale['event-team-required'])
                }
                else if (!this.event.eventType) {
                    Toast(this.locale['event-type-required'])
                }
                else if (gameEvent.validateEventSpecTypeRequired(this.event.eventType) && !this.event.eventSpecType) {
                    Toast(this.locale['event-spec-type-required'])
                }
                else if (!this.event.firstPlayerId) {
                    Toast(this.locale['event-player-required'])
                }
                else if (!this.event.secondPlayerId) {
                    Toast(this.locale['event-player-required'])
                }
            }
            else {
                // enable to submit
                this.submitData()
            }
        },
        onDeleteBtnClick() {
            console.log('onDeleteBtnClick')
            Dialog.confirm({
                title: this.locale['delete-event'],
                message: this.locale['delete-event-confirm-message']
            }).then(() => {
                // on confirm
                this.$emit('custom-event', {
                    type: 'delete'
                })
            }).catch(() => {
                // on cancel
            })
        },
        validateSubmitRequired() {
             console.log('validateSubmitRequired', this.event.time, this.event.teamId, this.event.firstPlayerId, gameEvent.validateSecondPlayerRequired(this.event.eventType), this.event.secondPlayerId)
            if (this.event.time 
                && this.event.teamId 
                && this.event.eventType 
                && (!gameEvent.validateEventSpecTypeRequired(this.event.eventSpecType) || this.event.eventType)
                && this.event.firstPlayerId
                && (!gameEvent.validateSecondPlayerRequired(this.event.eventType) || this.event.secondPlayerId)) {
                return true
            }
            return false
        },
        submitData() {
            console.log('submitData', this.event)
            if (this.validateSubmitRequired()) {
                const event = ObjectFunc.cloneObject(this.event)
                event.gameId = this.game.gameId
                this.$emit('custom-event', {
                    type: 'submit',
                    data: event
                })
            }
        },
    },
}
</script>

<template>
    <div class="game-event-edit">
        <van-field 
            v-model="event.time"
            :label="locale['time']"
            :placeholder="locale['game-time-placeholder']"
            :autofocus="true"
            type="digit"
            clearable
            input-align="right"
            maxlength="3"
            @input="onFieldInput"
        />
        <radio-group-field
            :label="locale['team']"
            :groupList="teamList"
            :value="team"
            @change-data="onTeamDataChange"
        />
        <radio-group-field
            v-if="event.teamId"
            :label="locale['event']"
            :groupList="eventTypeList"
            :value="eventType"
            @change-data="onEventTypeDataChange"
        />
        <radio-group-field
            v-if="hasEventSpecTypeList"
            :label="locale['type']"
            :groupList="eventSpecTypeList"
            :value="eventSpecType"
            @change-data="onEventSpecTypeDataChange"
        />
        <picker-selector
            v-if="event.eventType"
            :label="firstPlayerLabel"
            :options="firstPlayerList"
            :value="firstPlayerField"
            @change-data="onFirstPlayerDataChange"
        />
        <picker-selector
            v-if="secondPlayerLabel"
            :label="secondPlayerLabel"
            :options="secondPlayerList"
            :value="secondPlayerField"
            @change-data="onSecondPlayerDataChange"
        />
        <bottom-toolbar 
            v-if="!isEdit"
            type="button" 
            :mainButtonLabel="locale['submit']"
            :mainButtonDisabled="!validateSubmitRequired()"
            @click-main-button="onSubmitBtnClick"
        />
        <bottom-toolbar 
            v-else
            type="button-button" 
            :mainButtonLabel="locale['submit']"
            :mainButtonDisabled="!validateSubmitRequired()"
            :minorButtonLabel="locale['delete']"
            @click-main-button="onSubmitBtnClick"
            @click-minor-button="onDeleteBtnClick"
        />
    </div>
</template>